<template>
    <div>
        <staff-add-new :is-add-new-staff-sidebar-active.sync="isAddNewStaffSidebarActive" :role-options="roleOptions" :plan-options="planOptions" :status-options="statusOptions" :center-options="centerOptions" :group-options="groupOptions" @clicked="one" />
        <b-overlay :show="loading" opacity="0.5" background-color="#000">
            <b-card>
                <b-row>
                    <b-col cols="12" md="8" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <b-form-group>
                            <v-select v-model="perPage" label="Number of rows" :options="pageOptions" :clearable="false" />
                        </b-form-group>
                        <b-form-group class="ml-1" style="min-width: 150px;">
                            <v-select v-model="filter_status" label="label" :reduce="status => status.value" :options="statusOptions" :clearable="false" />
                        </b-form-group>
                        <b-form-group class="ml-1" style="min-width: 150px;">
                            <v-select v-model="filter_group" label="name" :reduce="group => group.id" :options="groupOptions" :clearable="false" />
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="12" md="4">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input v-model="searchString" class="d-inline-block mr-1" placeholder="Search..." />
                            <b-button variant="primary" @click="isAddNewStaffSidebarActive = true" v-if="client_type != 'individual'">
                                <span class="text-nowrap">Add User</span>
                            </b-button>
                            <!-- <b-button @click="test()">test</b-button> -->
                        </div>
                    </b-col>
                </b-row>
                <!-- table -->
                <b-table ref="selectableTable" selectable :select-mode="selectMode" :items="items" :fields="fields" small responsive striped class="mb-0" @row-selected="onRowSelected">
                    <template #cell(avatar)="data">
            <b-avatar
              class="mr-1"
              :src="'//www.cloudfit.pro/memberPhoto/'+data.item.uuid+'.jpg'"
            />
</template>

<template #cell(status_number)="data">
    <b-badge :variant="status[1][data.value]">
        {{ status[0][data.value] }}
    </b-badge>
</template>
    </b-table>
    <b-row>
      <b-col class="mt-1">
        Total : {{ totalRows }} , Display Row {{ startRow }} to {{ endRow }}
      </b-col>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          align="right"
          size="md"
          class="my-0"
          @change="handleChangePage"
        />
      </b-col>
    </b-row>
  </b-card>
  </b-overlay>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import {
    BTable,
    BCard,
    BAvatar,
    BOverlay,
    BCardBody,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BInputGroupPrepend,
} from 'bootstrap-vue'
import StaffAddNew from './StaffListAddNew.vue'

export default {
    components: {
        StaffAddNew,
        BCard,
        BTable,
        BAvatar,
        BBadge,
        BRow,
        BCol,
        BOverlay,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroupPrepend,
        BButton,
        BPagination,
        BCardCode,
        BTable,
        BButton,
        BFormGroup,
        BAvatar,
        BCardBody,
        BBadge,
        vSelect,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            loading: false,
            client_type: JSON.parse(localStorage.getItem('userData')).client_type,
            roleOptions: [
                { label: 'Admin', value: 'admin' },
                { label: 'Manager', value: 'manager' },
                { label: 'Staff', value: 'staff' },
                { label: 'Personal Trainer', value: 'pt' },
                { label: 'Rental PT', value: 'rental_pt' },
            ],
            planOptions: [
                { label: 'Basic', value: 'basic' },
                { label: 'Company', value: 'company' },
                { label: 'Enterprise', value: 'enterprise' },
                { label: 'Team', value: 'team' },
            ],
            statusOptions: [
                { label: 'Active', value: 'active' },
                { label: 'Disabled', value: 'disabled' },
                { label: 'All', value: 'all' },
            ],
            centerOptions: [],
            filter_status: 'active',
            filter_group: 'All',
            isAddNewStaffSidebarActive: false,
            searchString: null,
            perPage: 10,
            startRow: 1,
            endRow: 10,
            pageOptions: [10, 15, 20],
            groupOptions: [],
            totalRows: 1,
            currentPage: 1,
            fields: [
                { key: 'avatar', label: 'Avatar' }, 
                { key: 'username', label: 'Login Name' }, { key: 'display_name', label: 'Display Name' }, { key: 'group_name', label: 'Group' }, { key: 'status_number', label: 'STATUS' }
            ],
            /* eslint-disable global-require */
            items: [],
            /* eslint-disable global-require */
            status: [{
                    1: 'ACTIVE',
                    2: 'DISABLED',
                    3: 'Rejected',
                    4: 'Resigned',
                    5: 'Applied',
                },
                {
                    1: 'light-success',
                    2: 'light-danger',
                    3: 'light-danger',
                    4: 'light-warning',
                    5: 'light-info',
                }
            ],
            selectMode: 'single',
            selected: [],
        }
    },
    watch: {
        filter_group: {
            handler(newValue, oldValue) {
                this.handleSearch()
            },
        },
        filter_status: {
            handler(newValue, oldValue) {
                this.handleSearch()
            },
        },
        currentPage: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        searchString: {
            handler(newValue, oldValue) {
                // console.log("search")
                this.handleSearch()
            },
        },
        perPage: {
            handler(newValue, oldValue) {
                if (newValue < 9) {
                    this.perPage = 10
                }
                // console.log("search")
                this.handleSearch()
            },
        },
    },
    created() {
        this.get_group_data()
        this.get_data()
        this.get_center_data()
        this.get_group_data()
    },
    methods: {
        one() {
            this.isAddNewStaffSidebarActive = false
            this.get_data()
        },
        test() {


            const payload = {
                apiKey: "cd6f6f1f542635809d7e3251b01f3c2799d58ecb8d3de0fa177cb27e14766008",
                apiToken: "7cfb6158ccb9538d1fb19a525bf59497219ccc45e9aac4ee24e62359dd571860",
                messageId: "AIR00102",
                posId: "5f9b9e8d7cfde59ddc92a2b9165cb437c661b12a",
                currentTimeStamp: new Date().getTime(), // 替代 PHP 中的 {{currentTimestamp}}
                tranType: "SALE",
                requestAmount: 2,
                currency: "HKD",
                preferredInstrument: "CARD"
            };

            this.$http.post('http://192.168.253.129:8082/v1/payment', payload)
                .then(res => {
                    if (res.data.result === true) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        });
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message || 'Transaction failed',
                            },
                        });
                    }
                })
                .catch(error => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-center',
                        props: {
                            title: 'Network Error',
                            icon: 'XIcon',
                            variant: 'danger',
                            text: error.message,
                        },
                    });
                });




            // end test
        },
        get_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/staffs/?group=${this.filter_group}&status=${this.filter_status}&perpage=${this.perPage}&page=${this.currentPage}&search=${this.searchString}`)
                .then(res => {
                    this.loading = false
                    this.items = res.data.staffs
                    this.totalRows = res.data.total
                    this.startRow = res.data.startRow
                    this.endRow = res.data.endRow
                    //  console.log( res.data.members.length)
                })
        },
        get_group_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + '/groups/')
                .then(res => {
                    this.groupOptions = res.data.groups
                })
        },
        get_center_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + '/centers/')
                .then(res => {
                    this.centerOptions = res.data.centers
                })
        },
        handleChangePage() {

            //  this.get_data()
        },
        onRowSelected(items) {
            this.selected = items
            console.log(items)
            this.$router.push(`/apps/staff/edit/${items[0].uuid}/`)
        },
        selectAllRows() {
            this.$refs.selectableTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected()
        },
        selectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.selectRow(2)
        },
        unselectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.unselectRow(2)
        },

        handleSearch() {
            this.loading = true
            this.searchTimeOut()
        },
        searchTimeOut() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            this.timer = setTimeout(() => {
                // your code
                this.currentPage = 1
                this.get_data()
            }, 500)
        },
    },
}
</script>

<style lang="scss">
.b-table-selectable {
    .feather {
        font-size: 1.3rem;
    }
}
</style>
